import { Statistic } from 'antd';
import styled from 'styled-components';

export default styled(Statistic)`
	// Add your styles here
`;
